import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsFullReleaseList } from '../../data-provider/select-options';

export const useGetRegularReleaseList = () => {
  return useQuery({
    queryKey: ['pre-claims-regular-release-list'],
    queryFn: () => fetchPreClaimsFullReleaseList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
